/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
import React, { Suspense, useRef } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'gatsby';
import Marquee from 'react-fast-marquee';
import {
  Box,
  Container,
  DetailsLink,
  Figure,
  GatsbyImage,
  Grid,
  Image,
  Layout,
  Section,
  Testimonials,
  Typography,
} from '../components';
import { businessItems, features, industries, clients } from '../config/data';
import { useVisibleContactForm } from '../hooks';
import mobileImg from '../images/home/mobile.svg';

const ContactForm = React.lazy(() => import('../components/ContactForm'));

const heroImage = `data:image/png;base64,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`;

const HeroBg = styled.div`
  width: 100%;
  height: 80vh;
  position: absolute !important;
  background-repeat: no-repeat;
  background-position: top center;
  z-index: 0;
  top: -50px;
  background-size: cover;
  background-image: url(${heroImage});
`;

const ServiceItems = styled.div`
  background-color: #061324;
  padding: 18px;
  transition: 0.3s all ease;
  position: relative;
  text-align: center;
  &:hover {
    background-color: #142944;
  }
`;

const TechBox = styled.div`
  border: 1px solid #152539;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const techBoxVariants = {
  initial: { opacity: 0, y: 20 },
  hover: { scale: 1.1 },
  enter: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};
const TechGroup = styled.div`
  position: relative;
  background: linear-gradient(145deg, #081928, #061324);
  border: 1px solid #152539;
  border-radius: 12px;
  padding: 24px;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(to right, #f66d1d, #188dcd);
  }
`;

const TechGroupTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  margin-bottom: 16px;
  background: linear-gradient(to right, #f66d1d, #188dcd);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

const TechChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const TechChip = styled.span`
  display: inline-block;
  background: rgba(24, 141, 205, 0.07);
  border: 1px solid rgba(24, 141, 205, 0.18);
  border-radius: 20px;
  padding: 4px 12px;
  font-size: 12px;
  color: #94b8cc;
`;

const techGroups = [
  {
    title: 'Frontend Engineering',
    items: [
      'React',
      'Next.js',
      'Angular',
      'Tailwind CSS',
      'ShadCN UI',
      'WebSocket',
    ],
  },
  {
    title: 'Mobile App Development',
    items: [
      'React Native',
      'Expo',
      'Native mobile integrations',
      'App Store Deployment',
    ],
  },
  {
    title: 'Backend Engineering',
    items: ['Node.js', 'TypeScript', 'Express.js', '.NET Core'],
  },
  {
    title: 'Database & Data Layer',
    items: [
      'PostgreSQL',
      'MySQL',
      'MongoDB',
      'SqlServer',
      'Prisma',
      'Cosmos DB',
    ],
  },
  {
    title: 'Cloud & DevOps',
    items: ['AWS', 'Azure', 'Docker', 'CI/CD', 'Terraform'],
  },
  {
    title: 'Automation & Integrations',
    items: [
      'REST APIs',
      'Third-party SDKs',
      'Payment gateways',
      'Workflow automation',
    ],
  },
  {
    title: 'AI & Data',
    items: ['OpenAI', 'Claude', 'LangChain', 'OpenCV', 'Analytics'],
  },
  {
    title: 'E-commerce',
    items: ['WordPress', 'Custom storefronts', 'Payment/order automation'],
  },
];

const ValueBox = motion(
  styled.div`
    background-color: #061324;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    margin: 10px;
    height: 150px;
    position: relative;
    perspective: 1000px;

    @media (max-width: 768px) {
      padding: 15px;
      margin: 5px;
    }

    .inner-box {
      position: absolute;
      width: 100%;
      height: 100%;
      transition: opacity 0.5s ease;
    }

    .initially,
    .after-hover {
      position: absolute;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      backface-visibility: hidden;
    }

    .initially {
      opacity: 1;
    }

    .after-hover {
      opacity: 0;
    }

    &:hover .initially {
      opacity: 0;
    }

    &:hover .after-hover {
      opacity: 1;
    }
  `
);

const IndexPage = () => {
  const ref = useRef();
  // const onScreen = useOnScreen(ref, '-50px');
  const showContactForm = useVisibleContactForm(false);
  return (
    <Layout>
      <HeroBg />
      <Box position="relative" zIndex="var(--mid-index)" mt={{ _: 6, md: 8 }}>
        <Container>
          <Grid
            gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr' }}
            position="relative"
            zIndex="100"
            p={{ _: 2, md: 0 }}
          >
            <Box width="90%" minHeight="240px" mb={{ _: 4, md: 0 }} mt={[0, 3]}>
              <Typography
                variant="heading1"
                lineHeight={{ sm: '36px', md: '60px' }}
              >
                We <span>reinforce</span> aspiring businesses with end-to-end{' '}
                <em>software solutions</em> and bring <span>ideas to life</span>
              </Typography>
            </Box>
            <Box>
              {features.map(feature => (
                <Box key={feature.title} display="flex" mb={4}>
                  {feature.icon}
                  <Box width="80%" ml={2}>
                    <Typography variant="heading5">{feature.title}</Typography>
                    <Typography variant="paragraph2" my={1}>
                      {feature.content}
                    </Typography>
                    <DetailsLink to={feature.link}>
                      {feature.linkLabel}
                    </DetailsLink>
                  </Box>
                </Box>
              ))}
            </Box>
          </Grid>
          <Section mt={4}>
            <Grid gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr' }}>
              <Box>
                <GatsbyImage src="home/about.png" alt="About Us" />
              </Box>
              <Box>
                <Typography variant="heading3" mb={3}>
                  Get to know us
                </Typography>
                <Typography variant="paragraph2">
                  At Spring Rain, we are dedicated to bringing out the best
                  possible solutions at all development stages. Keeping in mind
                  your business's intention, we put your products and services
                  at the forefront of our priority mindset. Being in this
                  industry for over 10+ years has given us valuable insights
                  that we apply and further advance your development process.
                  The idea of always being up to date with the latest technology
                  is embedded in our DNA.
                </Typography>
                <DetailsLink mt={2} to="/about/">
                  Read more about us
                </DetailsLink>
              </Box>
            </Grid>
          </Section>
          <Section ref={ref}>
            <Grid gridTemplateColumns={{ _: '1fr', sm: '1fr' }}>
              <Box>
                <Typography
                  style={{ textAlign: 'center' }}
                  variant="heading3"
                  mb={3}
                >
                  Get Customized Support Now!
                </Typography>

                <Grid gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr 1fr 1fr' }}>
                  {businessItems.slice(0, 4).map(business => (
                    <ServiceItems key={business.label}>
                      <Box
                        mb={2}
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <motion.div
                          whileHover={{ scale: 1.2 }}
                          whileTap={{ scale: 0.8 }}
                        >
                          <Image
                            style={{
                              width: '60px',
                              height: '60px',
                              objectFit: 'contain',
                              padding: '10px',
                              backgroundColor: '#f66d1d',
                              marginBottom: '10px',
                            }}
                            src={business.icon}
                            alt={business.title}
                          />
                        </motion.div>
                      </Box>

                      {/* <Link to={business.link}>
                        <Typography variant="heading5" mb={1}>
                          {business.label}
                        </Typography>
                      </Link> */}

                      {business.link ? (
                        <Link to={business.link}>
                          <Typography variant="heading5" mb={1}>
                            {business.label}
                          </Typography>
                        </Link>
                      ) : (
                        <Typography
                          style={{ color: '#f66d1d' }}
                          variant="heading5"
                          mb={1}
                        >
                          {business.label}
                        </Typography>
                      )}

                      <Typography variant="paragraph2" mb={2}>
                        {business.content}
                      </Typography>

                      {business.list && business.list.length > 0 && (
                        <div style={{ marginBottom: '10px' }}>
                          <div
                            style={{
                              listStylePosition: 'inside',
                              fontSize: '12px',
                              lineHeight: '26px',
                            }}
                          >
                            {business.list.join(', ')}
                          </div>
                        </div>
                      )}

                      {/* <DetailsLink
                        mt={2}
                        style={{ position: 'absolute', bottom: '12px' }}
                        to={business.link}
                        variant="underline"
                      >
                        {business.learnMore}
                      </DetailsLink> */}
                    </ServiceItems>
                  ))}
                </Grid>

                <Box display="flex" justifyContent="flex-end" mt={6}>
                  <DetailsLink to="/expertise/">
                    Explore More Expertise
                  </DetailsLink>
                </Box>
              </Box>
              <Box display={['none', 'none', 'none']}>
                {/* TODO: change image according to business item */}
                <Figure
                  src={mobileImg}
                  alt="Improve your Business now!"
                  barColor="#008FD4"
                  barPosition="left"
                  position="right"
                  width="80%"
                />
              </Box>
            </Grid>
          </Section>

          <Section>
            <Typography
              style={{ textAlign: 'center' }}
              variant="heading3"
              mb={3}
            >
              Industries We Served
            </Typography>

            <Grid
              gridTemplateColumns={{
                _: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr 1fr',
              }}
            >
              {industries.map((industry, index) => (
                <ValueBox
                  key={industry.label}
                  initial="initial"
                  animate="enter"
                  exit="exit"
                  whileHover="hover"
                  variants={techBoxVariants}
                  transition={{ duration: 0.5 }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="heading4">{industry.label}</Typography>
                    <span>Projects Completed</span>
                    <Typography variant="heading6">
                      {industry.projectsCompleted}
                      {index % 2 === 0 ? '+' : ''}
                    </Typography>
                  </div>
                </ValueBox>
              ))}
            </Grid>
          </Section>

          <Section>
            <Typography
              style={{ textAlign: 'center' }}
              variant="heading3"
              mb={3}
            >
              Our Client
            </Typography>
            <Marquee pauseOnHover gradient="50" gradientColor="#020A14">
              {/* <Grid
                // gridTemplateColumns={{
                //   _: '1fr',
                //   sm: '1f 1f',
                //   md: '1fr 1fr 1fr 1fr 1fr',
                // }}
              > */}
              {clients.map((client, index) => (
                <Box mx={2} key={index}>
                  <TechBox>
                    <Image
                      mx={3}
                      width="100px"
                      src={client}
                      alt="Our clients"
                    />
                  </TechBox>
                </Box>
              ))}
              {/* </Grid> */}
            </Marquee>
          </Section>

          <Section>
            <Typography
              style={{ textAlign: 'center' }}
              variant="heading3"
              mb={6}
            >
              Our Tech Stack
            </Typography>
            <Grid
              gridTemplateColumns={{
                _: '1fr',
                sm: '1fr 1fr',
                md: '1fr 1fr 1fr 1fr',
              }}
              gap="28px"
            >
              {techGroups.map(group => (
                <TechGroup key={group.title}>
                  <TechGroupTitle>{group.title}</TechGroupTitle>
                  <TechChips>
                    {group.items.map(item => (
                      <TechChip key={item}>{item}</TechChip>
                    ))}
                  </TechChips>
                </TechGroup>
              ))}
            </Grid>
          </Section>

          <Section>
            <Testimonials />
          </Section>
          {showContactForm && (
            <Section>
              <Suspense fallback={<div />}>
                <ContactForm />
              </Suspense>
            </Section>
          )}
        </Container>
      </Box>
    </Layout>
  );
};

export default IndexPage;
